import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { Link } from "react-router-dom";
import ShopSettingDTO from "@/dto/shop/ShopSettingDTO";
import { getSubscribeUrlByShopSetting } from "@/services/subscribeServices";

interface SubscribeButtonProps {
    shopSetting: ShopSettingDTO;
}

const SubscribeButton: React.FC<SubscribeButtonProps> = function (props) {
    const { shopSetting } = props;
    const [subscribeUrl, setSubscribeUrl] = useState("");
    const [isLink, setLink] = useState(false);

    // 获取店铺续费链接
    useEffect(() => {
        const subscribeUrl = getSubscribeUrlByShopSetting(shopSetting);

        if (!subscribeUrl) {
            setLink(true);
            setSubscribeUrl(`/setting/shop/appSubscription/index?shopId=${shopSetting.id}`);

            return;
        }

        setSubscribeUrl(subscribeUrl);
    }, [shopSetting]);

    if (!subscribeUrl) {
        return null;
    }

    const button = <Button type="primary">立即续费</Button>;

    if (isLink) {
        return <Link to={subscribeUrl}>{button}</Link>;
    }

    return (
        <a href={subscribeUrl} target="_blank">
            <Button type="primary">立即续费</Button>
        </a>
    );
};

export default React.memo(SubscribeButton);
